<template>
    <div>
        <div class="shareCard">
            <span>{{ $t('common.quickShare') }}</span>
        </div>
        <div class="menuLinkWrapper">
            <van-row class="shareField">
                <van-col span="6" class="text1">ink de Indicação:</van-col>
                <van-col span="14" class="text2">{{ activityConfig?.link }}</van-col>
                <van-col span="4" class="text3" @click="onCopyID(activityConfig?.link)">{{ $t('common.copy') }}</van-col>
            </van-row>
            <p class="menueLinkBtTxt">{{ $t('common.quickShare') }}</p>
            <div style="display: flex;" class="mediaListMain">
                <div v-for="(item, index) in mediaList" :key="index" class="mediaList" @click="goToShare"
                    style="display: flex; flex-direction: column; justify-content: center;align-items: center; padding: 8px;">
                    <img :src="item.icon" style="height: 24.75px; width: 24.75px;" class="" alt="">
                    <p style="color:#b4e6ec; font-size: 9px;">{{ $t(item.name) }}</p>
                </div>
            </div>
            <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { getActivityInformations } from '@/api/common'
import { InfoConfig, MEDIA_LIST } from '@/view/bauDoTesouro/supportScript'
import { Share } from '@capacitor/share';
import { onMounted, ref } from 'vue'
import InputField from '../../bauDoTesouro/components/inputField.vue';
import { copyID } from '@/view/profile/supportScript';
import StatusPopup from '@/components/common/statusPopup.vue';

const mediaList = ref(MEDIA_LIST)
const activityConfig = ref<InfoConfig>({
    equipment_limit: '',
    ip_limit: '',
    recharge_require: '',
    turnover_require: '',
    turnover_require_times: '',
    valid_user_count: 0,
    link: '',
    reward_conf: []
})
const statusRef = ref()
const onCopyID = (id: any) => copyID(statusRef, id)
const getActivityInfo = () => {
    let data = {
        activityId: "user_referral_reward"
    }

    getActivityInformations(data).then(res => {

        const resData = res.data
        // bannerIcon.value = resData?.floatIcon
        // descriptionHtml.value = JSON.parse(resData.activityIntro)
        activityConfig.value = resData.config
        // activityStore.setActivityData(resData.config.recharge_require, resData.config.turnover_require, resData.config.ip_limit)
    }).catch(err => {
        console.error('Error fetching activity info:', err)
    })
}
const goToShare = async () => {
    let shareLink = activityConfig.value?.link
    if (!shareLink) { return }
    
    try {
        // Try Web Share API first (Chrome, Edge, mobile browsers)
        if (navigator.share && !isFirefox()) {
            await navigator.share({
                text: shareLink,
                title: 'Referral Link'
            });
        } else {
            // Firefox and other browsers: copy to clipboard
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(shareLink);
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = shareLink;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }
            statusRef.value?.open();
        }
    } catch (error) {
       console.warn('Share failed:', error) 
    }
}

const isFirefox = () => {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}
onMounted(() => {
    getActivityInfo()
})
</script>

<style scoped>
.menuLinkWrapper {
    position: relative;
    /* width: 100%; */
    display: flex;
    justify-content: center;
    background-color: #3f2e4b;
    border-radius: 10px;
    margin: 10px;
    padding: 20px 10px 10px;
    flex-direction: column;
}

.shareField {
    background: #291632;
    border: 1px solid #65436f;
    padding: 10px;
    border-radius: 10px;
}

.text1 {
    display: flex;
    align-items: center;
    color: #86718c;
    font-size: 11px;
    padding: 5px;
}

.text2 {
    display: flex;
    align-items: center;
    color: gold;
    font-size: 11px;
    padding: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
}

.text3 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00ff06;
    font-size: 11px;
    padding: 5px;
}

.menueLinkBtTxt {
    color: #ffffffd9;
    font-size: 13px;
    display: flex;
    text-align: center;
    justify-content: center;
    z-index: 1;

}

.mediaListMain {
    display: flex;
    justify-content: center;
}

.shareCard {
    padding: 10px 0;
    margin-left: 15px;
    font-size: 17px;
    color: #FFF;
    font-weight: 800;
}
</style>
